var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoteOnBehalfOf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.332c0 .229.188.416.417.416h2.16l-.277 1.323a.466.466 0 0 0 .127.429l.332.331 2.058-2.058a.62.62 0 0 0 .183-.441v-2.708a.624.624 0 0 0-.625-.625h-2.813a.623.623 0 0 0-.574.381l-.944 2.205a.624.624 0 0 0-.044.226v.521z",
    fill: "#F4FFFB",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 4.564A2.15 2.15 0 0 0 11.852 4c-1.146 0-2.075.862-2.075 1.925 0 1.064.928 1.927 2.074 1.927 1.145 0 2.074-.862 2.074-1.925 0-.511-.218-1.001-.607-1.363z",
    fill: "#DEFDE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.103 8.445h-.204a3.907 3.907 0 0 0-3.9 3.896v.275c0 .15.123.273.275.273h7.452a.274.274 0 0 0 .274-.273v-.275a3.909 3.909 0 0 0-3.897-3.896z",
    fill: "#DEFDE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.5a.418.418 0 0 0-.417-.417h-2.16l.277-1.322a.466.466 0 0 0-.127-.43L10.24 12l-2.058 2.058A.622.622 0 0 0 8 14.5v2.707c0 .346.28.625.625.625h2.813c.258 0 .48-.156.575-.38l.943-2.205A.631.631 0 0 0 13 15.02v-.52z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0,
    x2: -0.598,
    y2: 0.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteOnBehalfOf);
export default __webpack_public_path__ + "static/media/voteOnBehalfOf.1c5857959e14a7358373ff0f8147011d.svg";
export { ForwardRef as ReactComponent };